<div class="duna-events-schedule" [class.compact]="compact">
  @if (showViewToggle) {
  <div class="schedule-toolbar">
    <mat-button-toggle-group
      class="view-toggle-group compact"
      [value]="scheduleView"
      (change)="onViewChange($event.value)"
      [hideSingleSelectionIndicator]="true"
    >
      @for (opt of viewOptions; track opt.value) {
      <mat-button-toggle [value]="opt.value">
        <mat-icon>{{ opt.icon }}</mat-icon>
        <span class="toggle-label">{{ opt.label }}</span>
      </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
  }
  <div class="schedule-host" [class.loading]="loading">
    @if (loading) {
    <div class="schedule-loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    }
    <ejs-schedule
      #scheduleObj
      class="duna-kalender duna-events-schedule-inner"
      [selectedDate]="selectedDate"
      [firstDayOfWeek]="1"
      [showWeekNumber]="true"
      weekRule="FirstFourDayWeek"
      locale="da"
      [currentView]="scheduleView"
      startHour="06:00"
      endHour="22:00"
      [eventSettings]="eventSettings"
      [readonly]="true"
      [rowAutoHeight]="false"
      [showQuickInfo]="false"
      (eventClick)="onScheduleEventClick($event)"
      (eventRendered)="onEventRendered($event)"
      (navigated)="onNavigated($event)"
      (actionComplete)="onActionComplete($event)"
    >
      <e-views>
        <e-view option="Day"></e-view>
        <e-view option="Week"></e-view>
        <e-view option="Month"></e-view>
        <e-view option="Year"></e-view>
      </e-views>
    </ejs-schedule>
  </div>
</div>
